import { memo } from "react";
import { useTheme } from "@mui/material/styles";
import type { TaxonomyUrn } from "@shared/types/taxonomy.ts";
import { useTaxonomy } from "../../../../context/TaxonomyProvider";
import { getDomainIcon } from "../../../../domain_icons";
import { ShieldBadge } from "../../../primitives/data-display/ShieldBadge";

export interface TaxonomyUrnBadgeProps {
  urn: TaxonomyUrn;
}

/** Two-segment badge for a taxonomy URN: domain name on the left, field label on the right.
 *  Domain-level URNs render as a single segment. Unknown URNs render nothing. */
export const TaxonomyUrnBadge = memo(function TaxonomyUrnBadge({ urn }: TaxonomyUrnBadgeProps) {
  const theme = useTheme();
  const node = useTaxonomy().find(urn);
  if (!node) return null;

  const domainName = node.domain?.enName ?? "";
  const domainKey = node.domainKey ?? undefined;
  const labelColor = domainKey ? theme.domains[domainKey] : undefined;
  const icon = domainKey ? getDomainIcon(domainKey) : undefined;

  if (!node.isField) {
    return <ShieldBadge label={domainName} labelColor={labelColor} icon={icon} />;
  }

  return <ShieldBadge label={domainName} value={node.enName} labelColor={labelColor} icon={icon} />;
});
